import { render } from "./EditContract.vue?vue&type=template&id=5812615e&scoped=true"
import script from "./EditContract.vue?vue&type=script&lang=js"
export * from "./EditContract.vue?vue&type=script&lang=js"

import "./EditContract.vue?vue&type=style&index=0&id=5812615e&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5812615e"]])

export default __exports__